module.exports = new __parcel__URL__("JiraServiceManagement.0b0134a3.svg").toString();